module.exports = __webpack_public_path__ + "static/img/4.4374af5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha/4.png
// module id = A1e1
// module chunks = 1